<div class="infigoContain">
    <div class="detail">
        <div class="list">
            <infigo-list [formatNumInaccurate]="formatNumInaccurate"
                [formatNum]="formatNum"
                [noResultTip]="noResultTip"
                [skeletonTemplateRef]="skeletonTemplate"
                [title]="i18n.get('home.Home_network_resources_lab')"></infigo-list>
        </div>
        <div class="detail-block">
            <infigo-detail></infigo-detail>
        </div>
    </div>
    <div class="right">
        <div>
            <infigo-base-list
                [formatNum]="formatNum"
                [more]="true"
                [noResultTip]="noResultTip"
                [title]="i18n.get('monitor.alarm_term_type_event_label').slice(i18n.language==='zh'?-2:-6)"
                icon="#infigo-event"
                providerType="event"
            ></infigo-base-list>
        </div>
        <div>
            <infigo-base-list
                [formatNum]="formatNum"
                [more]="true"
                [noResultTip]="noResultTip"
                [title]="i18n.get('common.Alarms')"
                icon="#infigo-alarm"
                providerType='alarm'
            ></infigo-base-list>
        </div>
    </div>
</div>
<ng-template #skeletonTemplate>
    <div style="margin-bottom: 1px;">
        <app-skeleton [height]="'47px'" [loading]="true"></app-skeleton>
    </div>
</ng-template>
